// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/system/errors.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_common } from "../core/common_pb";

/**
 * Describes the file proto/model/system/errors.proto.
 */
export const file_proto_model_system_errors = /*@__PURE__*/
  fileDesc("Ch9wcm90by9tb2RlbC9zeXN0ZW0vZXJyb3JzLnByb3RvEgZjYXJtZW4iaAoFRXJyb3ISDgoGc3RhdHVzGAEgASgFEgwKBGNvZGUYAiABKAMSIgoIc2V2ZXJpdHkYAyABKA4yEC5jYXJtZW4uU2V2ZXJpdHkSDQoFdGl0bGUYBCABKAkSDgoGZGV0YWlsGAUgASgJQi9aLWdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL3N5c3RlbWIGcHJvdG8z", [file_proto_model_core_common]);

/**
 * Describes the message carmen.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema = /*@__PURE__*/
  messageDesc(file_proto_model_system_errors, 0);

